<form style="text-align: left; margin-bottom: 15px;" novalidate [formGroup]="group">

    <!--
      Doppio binding intenzionale: formControlName="data" alimenta SOLO il messaggio di
      validazione (required), mentre [ngModel]/[(date)] porta il valore effettivo usato
      dal bottone Salva del genitore (globalData.dataXRistorante). NON rimuovere uno dei
      due: senza ngModel il Salva non vedrebbe la data, senza formControlName sparirebbe
      l'errore "required". La migrazione a ControlValueAccessor va fatta come task a parte.
    -->
    <div class="relative inline-flex w-full items-center">
        <i class="fas fa-calendar-alt pointer-events-none absolute left-3 z-10 text-[13px] text-brand-500"></i>
        <input formControlName="data"
               [class.border-rose-400]="group.get('data')?.invalid && group.get('data')?.touched"
               autocomplete="off"
               class="h-9 w-full cursor-pointer rounded-full border border-brand-200 bg-brand-50 pl-9 pr-4 text-[13px] font-semibold text-ink shadow-sm placeholder:text-muted transition-colors hover:border-brand-400 hover:bg-brand-100 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-400"
               (click)="dp.toggle()"
               placeholder="gg-mm-aaaa"
               [ngModel]="date"
               (ngModelChange)="dateChange.emit($event)"
               ngbDatepicker #dp="ngbDatepicker">
    </div>

    <div no-lines *ngIf="group.get('data')?.hasError('required') && (!guardTouched || group.get('data')?.touched)">
        <div class="mt-1.5 text-[12px] font-semibold text-rose-600">
            Selezionare il giorno della prenotazione
        </div>
    </div>
</form>
